import { Box, Button, Grid } from "@compass/core";
import SignatureCanvas from "react-signature-canvas";
import { useEffect, useRef } from "react";

type SignatureBoxProps = {
  width: number;
  height: number;
  languageId: number;
  signature: any;
  onUpdate: (value: any) => void;
};

export const SignatureBox = ({ width, height, languageId, signature, onUpdate }: SignatureBoxProps) => {
  const sigCanvas: any = useRef(null);

  useEffect(() => {
    if (signature && sigCanvas.current) {
      sigCanvas.current.fromDataURL(signature);
    }
  }, []);

  const handleEnd = () => {
    if (sigCanvas.current) {
      onUpdate(sigCanvas.current.toDataURL());
    }
  };

  return (
    <Grid container spacing="sm">
      <Grid item xs={12}>
        <Box sx={{ width, height, backgroundColor: "white", border: '1px solid black' }}>
          <SignatureCanvas
            penColor="black"
            onEnd={handleEnd}
            ref={sigCanvas}
            canvasProps={{ width, height }}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Button variant="contained" onClick={() => sigCanvas.current.clear()}>
          {languageId === 2 ? "Borrar" : "Clear"}
        </Button>
      </Grid>
    </Grid>
  );
};